import React from 'react';
import FeatureCards from "../../../../components/FeatureCards/FeatureCards";
import CTA from "../../../../components/Constant/cta/CTA";
import TimelineSection from "../../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../../components/WhySection/WhySection";
import LocationTimeline from "../../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../../components/ServiceCards/ServiceCards";
import SEO from "../../../../utils/SEO";

export default function InsuranceReinsuranceLicensePanama() {

    return (
        <main className='main'>
            <SEO
                title="Panama Crypto License | CASP Exchange & Wallet Setup "
                description="Launch a crypto exchange or wallet business in Panama under CASP Law 697. Tax-efficient jurisdiction with strong compliance and regulatory support. "
                keywords="Panama crypto license, CASP Panama, crypto exchange Panama, crypto wallet Panama, token issuance Panama, blockchain services Panama, crypto PSP Panama, offshore crypto regulation "
                url="/insurance-reinsurance-license-panama"
            />

            <IntroSection
                title="Insurance & Reinsurance License – Panama"
                subtitle="Establish an Insurance or Reinsurance Company in Panama"
                description="
                <b>Panama</b> is one of the <b>most recognized jurisdictions</b> in <b>Latin America</b> for <b>insurance and reinsurance</b>. Regulated by the <b>Superintendence of Insurance and Reinsurance of Panama</b>, it provides a <b>robust legal framework</b> for <b>life, non-life, captive, and reinsurance companies</b>.
                                <br/>
                                With its <b>strategic geographic position</b>, <b>strong financial services sector</b>, and <b>territorial tax system</b>, <b>Panama</b> is an ideal base for <b>regional insurers</b>, <b>reinsurers</b>, and <b>global groups</b> looking to expand into <b>Latin America</b>.

                "
                badges={
                    [
                        "Life Insurance",
                        "Non-Life Insurance",
                        "Captives",
                        "Reinsurance"
                    ]
                }
                buttonText="Request a Panama Insurance Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../../assets/images/services/gibraltar-crypto-dlt-license-hero.png")}
                imageAlt=""
            />

            <section className='section'>
                <div className="container">

                    <WhySection
                        title='Why Choose Panama for Insurance & Reinsurance?'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                title: "Regional Hub",
                                                text: "Strong demand across Central & South America."
                                            },
                                            {
                                                title: "Trusted Regulator",
                                                text: "Superintendence of Insurance and Reinsurance."
                                            },
                                            {
                                                title: "Captive-Friendly",
                                                text: "Used by multinationals for risk management."
                                            },
                                            {
                                                title: "Tax Benefits",
                                                text: "Territorial tax system (no tax on foreign premiums)."
                                            },
                                            {
                                                title: "Global Connectivity",
                                                text: "Panama Canal makes it a logistics and insurance hub."
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="Types of Insurance & Reinsurance Licenses in Panama"
                        blocks={
                            [
                                {
                                    title: "Insurance License",
                                    items:
                                        [
                                            {
                                                title: "Life Insurance",
                                                text: "Personal, group, and health insurance policies."
                                            },
                                            {
                                                title: "Non-Life Insurance",
                                                text: "Property, liability, casualty, marine, aviation, and transport insurance."
                                            },
                                            {
                                                title: "Captive Insurance",
                                                text: "Corporations insuring their own risks through captive structures."
                                            }
                                        ]
                                },
                                {
                                    title: "Reinsurance License",
                                    items:
                                        [
                                            {
                                                title: "Full Reinsurance",
                                                text: "Operations for domestic and international markets."
                                            },
                                            {
                                                title: "Captive Reinsurance",
                                                text: "For corporate groups managing internal risk."
                                            },
                                            {
                                                title: "Retrocession",
                                                text: "Retrocession activities are permitted."
                                            }
                                        ]
                                },

                            ]
                        }
                    />

                    <LocationTimeline
                        title="Capital Requirements"
                        subtitle=''
                        item={
                            [
                                {
                                    title: "Insurance Companies",
                                    text: "Minimum capital requirement of USD 5 million."
                                },
                                {
                                    title: "Reinsurance Companies",
                                    text: "Minimum capital requirement of USD 10 million."
                                },
                                {
                                    title: "Captives",
                                    text: "Flexible capital rules depending on business scope."
                                }
                            ]
                        }
                    />

                    <ServiceCards
                        title='Benefits of a Panama Insurance License'
                        services={
                            [
                                {
                                    title: "Regional Recognition",
                                    text: "Trusted across Latin America."
                                },
                                {
                                    title: "Captive Solutions",
                                    text: "Efficient risk management structures."
                                },
                                {
                                    title: "Banking Hub Support",
                                    text: "Synergy with Panama’s financial sector."
                                },
                                {
                                    title: "Investor Confidence",
                                    text: "Respected regulator with strong oversight."
                                },
                                {
                                    title: "Tax-Friendly",
                                    text: "Foreign-sourced premiums are not taxed locally."
                                }
                            ]

                        }
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={
                            [
                                {
                                    title: "Pre-Application Consultation",
                                    text: "Select insurance or reinsurance model."
                                },
                                {
                                    title: "Company Incorporation",
                                    text: "Establish a Panamanian entity."
                                },
                                {
                                    title: "Application Submission",
                                    text: "Submit actuarial reports, financial projections, and AML/KYC policies."
                                },
                                {
                                    title: "Regulatory Review",
                                    text: "Fit & proper checks for shareholders and directors."
                                },
                                {
                                    title: "Approval & Licensing",
                                    text: "Typically 9–12 months."
                                }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={
                            [
                                {
                                    name: "Timeline",
                                    duration: "9–12 months.",
                                },
                                {
                                    name: "Setup Costs",
                                    description: "from USD 150,000+ (legal, actuarial, compliance)."
                                },
                                {
                                    name: "Capital Requirement",
                                    description: "USD 5M–10M depending on license."
                                },
                                {
                                    name: "Annual Costs",
                                    description: "actuarial reviews, audits, supervision fees."
                                },

                            ]
                        }
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                {
                                    text: "Specialists in insurance & reinsurance licensing."
                                },
                                {
                                    text: "End-to-end support: incorporation, license filing, actuarial reports."
                                },
                                {
                                    text: "Guidance on captives, risk transfer, and Solvency II comparison."
                                },
                                {
                                    text: "Network of local regulators, auditors, and actuaries."
                                },
                                {
                                    text: "Balanced advice: Panama vs Malta vs Cyprus vs Offshore centers."
                                }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to launch a regulated crypto business in Latin America?"
                        description="Panama offers crypto licensing under Law 697, with low barriers, tax advantages, and global flexibility."
                        buttonText="Book a Panama Crypto License Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};


const faqData = [
    {
        question: "What’s the capital requirement?",
        content: [
            { type: "answer", text: "USD 5M for insurers, USD 10M for reinsurers." },
        ],
    },
    {
        question: "Can Panama insurers operate globally?",
        content: [
            { type: "answer", text: "Yes — especially attractive for LatAm, MENA, and offshore captives." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "9–12 months on average." },
        ],
    },
    {
        question: "Is Panama good for captives?",
        content: [
            { type: "answer", text: "Yes — Panama is a strong base for multinational captive insurance." },
        ],
    },
    {
        question: "Are premiums taxed in Panama?",
        content: [
            { type: "answer", text: "Only Panama-sourced premiums are taxed. Foreign income is tax-exempt." },
        ],
    },
];

const testimonialsData = [
    {
        quote: "We licensed a reinsurance company in Panama. Offshore Advisory guided us through capital structuring and regulator filings.",
        author: "Javier M.",
        role: "Reinsurance Director"
    },
    {
        quote: "Panama was ideal for our captive insurance setup. Offshore Advisory made the process smooth and efficient.",
        author: "Laura S.",
        role: "Corporate Risk Manager"
    }
];

